import { Sessions } from './Settings.Sessions';

export default function SecuritySettings() {
  return (
    <Sessions />
  );
}

export { SecuritySettings };